import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { VendorService } from '@app/services';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'qb-confirm-account',
  templateUrl: './confirm-account.component.html',
  styleUrls: ['./confirm-account.component.scss'],
  imports: [RouterLink, MatButton],
})
export class ConfirmAccountComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  vendorToken: string;
  confirmationKey: string;
  isConfirmed: boolean = false;
  errorMessage: string = '';
  alreadyConfirmed: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private vendorService: VendorService
  ) {}

  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.vendorToken = params['vendorToken'];
      this.confirmationKey = params['confirmationKey'];
      this.vendorService
        .confirmVendorAccount(this.vendorToken, this.confirmationKey)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(res => {
          if (res.errorFound) {
            this.errorMessage = res.publicMessage;
          } else if (res.alreadyConfirmed) {
            this.alreadyConfirmed = true;
          } else {
            this.isConfirmed = true;
          }
        });
    });
  }
}
